import React, { Component } from "react";
import { Link, Outlet } from "react-router-dom";

import { withFirebase } from "../Firebase";
import { withAuthorization } from "../Session";

import "./index.css";
import { Button } from "antd";
import { DeleteOutlined, DownOutlined } from "@ant-design/icons";

/////// Timeline Home ///////
// Function: create new timeline
class HomePageBase extends Component {
  state = {
    loading: false,
    timelines: [],
    timelineTitle: "",
  };

  // Add event to firebase
  onSubmitTimeline = (event) => {
    event.preventDefault();

    // Get title input
    const newTimelineName = event.target[0].value;

    const newTimelineEntry = {
      title: newTimelineName,
    };

    if (this.state.timelines) {
      this.state.timelines.push(newTimelineEntry);
    } else {
      this.setState({
        timelines: newTimelineEntry,
      });
    }

    console.log("timeline array", this.state.timelines);

    var uid = this.props.firebase.auth.currentUser.uid;

    this.props.firebase.timelines(uid).push({
      ...newTimelineEntry,
    });
  };

  onRemoveTimeline = (tid) => {
    var uid = this.props.firebase.auth.currentUser.uid;
    this.props.firebase.getTimeline(uid, tid).remove();
  };

  onEditTimeline = () => {};

  componentDidMount() {
    this.setState({ loading: true });

    var uid = this.props.firebase.auth.currentUser.uid;
    this.props.firebase.timelines(uid).on("value", (snapshot) => {
      const timelinesObject = snapshot.val();

      if (timelinesObject) {
        const timelinesList = Object.keys(timelinesObject).map((key) => ({
          ...timelinesObject[key],
          uid: key,
        }));
        console.log("Events object to event list-", timelinesList);
        this.setState({
          timelines: timelinesList,
          loading: false,
        });
      } else {
        console.log("There's no timelines");
        this.setState({
          timelines: null,
          loading: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.props.firebase.timelines().off();
  }

  handleTitleChange = (event) => {
    this.setState({ title: event.target.value });
    event.preventDefault();
  };

  render() {
    const { timelines } = this.state;

    return (
      <div className="content-wrapper">
        {timelines ? (
          <div>
            <h1 className="header-title">Your timelines</h1>
            <TimelineList
              timelines={timelines}
              onRemoveTimeline={this.onRemoveTimeline}
            ></TimelineList>
          </div>
        ) : (
          <div>There are no timelines ...</div>
        )}

        <h1 className="header-title">Add a new timeline</h1>
        <form
          className="timeline-form"
          onSubmit={(e) => this.onSubmitTimeline(e)}
        >
          <input
            type="text"
            name="title"
            onChange={this.handleTitleChange}
            autoComplete="off"
            className="event-input input-title"
            placeholder="Timeline name"
          />

          <Button type="submit" className="btn-submit">
            Create timeline
          </Button>
        </form>

        <Outlet></Outlet>
      </div>
    );
  }
}

export const TimelineList = ({ timelines, onRemoveTimeline }) => (
  <div>
    {timelines.map((timelineItem) => (
      <TimelineItem
        key={timelineItem.uid}
        timelineItem={timelineItem}
        onRemoveTimeline={onRemoveTimeline}
      >
        {console.log("UID", timelineItem.uid)}
      </TimelineItem>
    ))}
  </div>
);

const TimelineItem = ({ timelineItem, onRemoveTimeline }) => (
  <div className="timeline-card" key={timelineItem.uid}>
    <div className="timeline-info formTitle">
      <Link to={`/home/${timelineItem.uid}`} key={timelineItem.uid}>
        <h2>{timelineItem.title}</h2>
      </Link>
    </div>
    <div className="timeline-options">
      <Button
        type="small"
        shape="circle"
        onClick={() => onRemoveTimeline(timelineItem.uid)}
        icon={<DeleteOutlined />}
      />
    </div>
    {/* <Button
      type="small"
      shape="circle"
      onClick={() => onRemoveTimeline(timelineItem.uid)}
      icon={<EditOutlined />}
    /> */}
  </div>
);

const HomePage = withFirebase(HomePageBase);

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(HomePage);
